import React, { useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {formatChatConversationTime, formatName} from "utils/format";
import talentAvatar from '../../../../assets/img/noAvatar.png';
import {
  getDetailTalentChat,
  setJobSelected,
  getMessages,
  getActions,
  setIsChatting,
  setChatSelected,
  setIsScout,
  updateConventionIsFlag,
  setChatList,
  setTalentSelected,
  getListJobRecommend, setIsNewChatFormOtherScreen, setTextInput, setIsDiscardUnsentMessagePopup,
  setIsMessageFormDirty,
  setFiles, setIsNewChat, setIsNewCompanyConversation,
} from "reducers/chatMessage";
import {ThunkDispatch} from "@reduxjs/toolkit";
import parse from "html-react-parser";
import CustomIconButton from "../../../components/CustomIconButton";
import { clearHTMLTag } from "../../../utils/format";
import {LoadingIcon, LoadingSpinner} from "components/Icons";
import ConfirmPopup from "../../../components/ConfirmPopup";
import {MESSAGE_TYPE} from '../../../constants/index';
import UnsaveConfirmPopup from "../../action/components/UnsaveConfirmPopup";

const ChatList = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  let {staffInfo} = useSelector((state: any) => state.currentUser)
  const { chatList, chatSelected, loadingGetListChat, textInput, isScout, isMessageFormDirty, isDiscardUnsentMessagePopup, isFlagFilter, globalFilterString } = useSelector((state: any) => state.chatMessage);
  const [isDiscardUnsentMessagePopup1, setIsDiscardUnsentMessagePopup1] = useState(false);
  const [pendingConversation, setPendingConversation] = useState(null);

  const handleSelectConvention = (e: any, item: any) => {
    e.preventDefault();
    if(isMessageFormDirty && !isDiscardUnsentMessagePopup1) {
      setPendingConversation(item);
      setIsDiscardUnsentMessagePopup1(true);
    } else {
      dispatch(setIsNewChat(false));
      dispatch(setIsChatting(true));
      dispatch(setIsNewChatFormOtherScreen(false));
      dispatch(setChatSelected(item));
      if (item?.talent && item?.talent?.id) {
        dispatch(setTalentSelected(item));
        dispatch(getDetailTalentChat({ id: item?.talent?.id }));

        // Get list job recommend
        const dataJob = { search: '', talentId: item?.talent?.id }
        dispatch(getListJobRecommend(dataJob));
      }

      if(item?.job && item?.job.id) {
        dispatch(setJobSelected(item?.job));
      } else {
        dispatch(setJobSelected({}));
      }
      if(item?.type && item?.type?.value == MESSAGE_TYPE.SCOUT) {
        dispatch(setIsScout(true));
      } else {
        dispatch(setIsScout(false));
      }
      dispatch(getMessages({ id: item?.id }));

      // Get list actions
      dispatch(getActions({ chatConversationId: item?.id }));

      // Update readed
      let newChatList = JSON.parse(JSON.stringify(chatList));
      for(let itemChat of newChatList) {
        if(itemChat.id == item?.id) {
          if(itemChat?.user_chat?.reads && !itemChat?.user_chat?.reads.includes(staffInfo.user_id)) {
            itemChat?.user_chat?.reads.push(staffInfo.user_id)
          }
          break
        }
      }
      dispatch(setChatList(newChatList));
    }
  };

  const handleUpdateIsFlag = (item: any) => {
    dispatch(updateConventionIsFlag({ id: item?.id }));

    if(checkIsFlag(item?.user_chat?.flags) && isFlagFilter && item?.id === chatSelected?.id) {
      dispatch(setJobSelected({}));
      dispatch(setChatSelected({}));
      dispatch(setTalentSelected({}));
      dispatch(setIsNewCompanyConversation(false));
      dispatch(setIsChatting(false));
    }
  };

  const checkIsFlag = (isFlags: any) => {
    if(!isFlags || isFlags.length == 0) {
      return false;
    }
    if (isFlags.includes(staffInfo.user_id)) {
      return true;
    }
    return false;
  };

  const handleConfirmDiscardUnsentMessage = (e) => {
    handleSelectConvention(e, pendingConversation);
    setPendingConversation(null);
    dispatch(setTextInput(""));
    dispatch(setFiles([]));
    setIsDiscardUnsentMessagePopup1(false);
    dispatch(setIsMessageFormDirty(false));
  }

  return (
    <div className="flex flex-col">
      {chatList?.length > 0 ?
        chatList.map((item: any, idx: any) => (
          <div key={idx}>
            <div
              className={`${
                chatSelected?.id && chatSelected?.id == item.id ? "border-[#FF861A]" : "border-transparent hover:cursor-pointer hover:bg-[#FFF3E5]"
              } border rounded-md px-[0.5rem] py-1 bg-white flex items-center gap-[0.25rem] ${idx !== 0 && "mt-1"} ${idx !== chatList?.length - 1 && "mb-1"}`}
            >
              <CustomIconButton
                variant="icononly"
                customStyle="shrink-0 !w-6 !h-6"
                onClick={() => handleUpdateIsFlag(item)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_8781_4373" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask={checkIsFlag(item?.user_chat?.flags) ? "url(#mask0_8781_4373)" : "url(#mask0_8781_4378)"}>
                    <path d={checkIsFlag(item?.user_chat?.flags) ? "M5 22V3H21L19 8L21 13H7V22H5Z"
                      : "M5 22V3H21L19 8L21 13H7V22H5ZM7 11H18.05L16.85 8L18.05 5H7V11Z"} 
                    fill={checkIsFlag(item?.user_chat?.flags) ? "#FF861A" : "#BBBBBB"}/>
                  </g>
                </svg>
              </CustomIconButton>
              <img
                className="shrink-0 w-10 h-10 rounded-full object-cover"
                src={item?.conversation_avatar ? item?.conversation_avatar : talentAvatar}
                alt="avatar"
              />
              <div className={`${chatSelected?.id === item?.id ? "pointer-events-none" : ""} flex-1`}
                onClick={(e: any) => handleSelectConvention(e, item)}>
                <div className="flex items-baseline justify-between mb-1 gap-2">
                  <p
                    className={`flex items-baseline gap-1 text-sm alu-text-base-2 break-all ${item?.user_chat?.reads?.includes(staffInfo.user_id) ? "" : "font-bold"}`}>
                    <span
                      style={{color: item.is_from_system ? '' : item?.conversation_name?.includes('自分') ? '#2182BA' : ''}}>
                      {item?.conversation_name}
                    </span>
                    {item?.type?.label && <span
                      className="shrink-0 rounded-2xl min-w-[3rem] px-[0.375rem] py-[0.125rem] text-center bg-[#CCE4FF] font-normal text-[0.75rem] leading-4">
                        {item?.type?.label}
                    </span>}

                  </p>
                  <p className="min-w-[2.75rem] shrink-0 text-sm font-normal alu-text-base-1 text-right">
                    {formatChatConversationTime(item.last_message?.send_at)}
                  </p>
                </div>
                <p className="text-sm font-normal alu-text-base-1 max-w-[17rem] sm:max-w-[13.75rem] xl:max-w-[17rem] truncate">
                  {staffInfo.user_id == item.last_message?.user_id && !item.last_message?.is_from_system ? '自分: ' + parse(clearHTMLTag(item.last_message?.content)) : parse(clearHTMLTag(item.last_message?.content))}
                </p>
              </div>
            </div>
            {idx !== chatList.length - 1 && (
              <div className="h-[1px] w-full bg-[#E0E0E0]"></div>
            )}
          </div>
        ))
        : !loadingGetListChat ?
        <div className="ml-[44px] text-sm mt-[21px] text-[#000] leading-[21px]">
          {isFlagFilter && Boolean(globalFilterString && (globalFilterString + "").trim()) ? (
            <p>指定した条件のメッセージは見つかりませんでした。</p>
          ) : isFlagFilter ? (
            <p>
              フラグ付きのメッセージはありません。<br />
              フラグを利用すると対応が必要なメッセージを見つけやすくなります。
            </p>
          ) : (
            <p>
              お探しのタレントは登録されていないようです。<br />
              別の名前 / ID でお探しください。
            </p>
          )}
        </div>
        :
        <></>
        }
      {loadingGetListChat && (
        <div className="flex items-center justify-center"><LoadingIcon/></div>
      )}

      {isDiscardUnsentMessagePopup1 && <UnsaveConfirmPopup
        open={isDiscardUnsentMessagePopup1}
        onClose={() => setIsDiscardUnsentMessagePopup1(false)}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={handleConfirmDiscardUnsentMessage}
      />}
    </div>
  );
};

export default ChatList;